/**
 * Global event bus for communicating between components that aren't directly related.
 *
 * Usage is simple:
 * import EventBus from '{relativePath}/event-bus/'
 * EventBus.emit(EventBus.EVENT.SOMENAME, payload);
 * EventBus.on(EventBus.EVENT.SOMENAME, callback);
 */
import Vue from 'vue';
const bus = new Vue();
//below we have to create wrapper functions for the methods otherwise the vm._events is undefined and lost
export default {
    EVENT : {
        SESSION_SET : 'sessionSet',
        ALL_PAYMENTS_DELETED : 'all_payments_deleted',
        ABSTRACT_SEARCH_DYNAMIC_FILTER_OPEN : 'abstract_search_dynamic_filter_open',
    },
    on : (event, callback) => {
        bus.$on(event, callback);
    },
    once : (event, callback) => {
        bus.$emit(event, callback);
    },
    off : (event) => {
        bus.$off(event);
    },
    emit : (event, data) => {
        bus.$emit(event, data);
    },
}
